<ng-container *transloco="let t">
  <mat-toolbar class="tool-bar">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="start center">
      <span style="font-size: 20px;">
        {{ id ? t("role.Update") : t("role.Create") }}
      </span>
      <span class="example-spacer"></span>
      <mat-icon mat-dialog-close>close</mat-icon>
    </mat-toolbar-row>
  </mat-toolbar>
  <form [formGroup]="roleForm" (ngSubmit)="save()">
    <mat-dialog-content class="mat-typography">
      <div fxLayout="row wrap" class="padding-top-bottom-10">
        <div fxFlex="100" [hidden]="true">
          <mat-form-field class="example-full-width">
            <input matInput placeholder="Id" formControlName="id" />
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>{{ t('role.Name') }}</mat-label>
            <input
              matInput
              placeholder="{{ t('role.Name') }}"
              formControlName="name"
            />
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field class="example-full-width" appearance="outline">
            <mat-label>{{ t('role.description') }}</mat-label>
            <input
              matInput
              placeholder="{{ t('role.description') }}"
              formControlName="description"
            />
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-radio-group
            aria-label="Active/Inactive"
            formControlName="active"
          >
            <mat-radio-button [value]="true">{{
              t("user.Active")
            }}</mat-radio-button>
            <mat-radio-button [value]="false">{{
              t("user.InActive")
            }}</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </mat-dialog-content>
    <div fxLayout="row" class="dialog-actions">
      <button mat-flat-button color="primary" type="submit">
        {{ id ? t("role.btnUpdate") : t("role.btnCreate") }}
      </button>
      <span class="margin-left-right-10">
        <button mat-stroked-button type="button" (click)="onClose()">
          {{ t("role.btnCancel") }}
        </button>
      </span>
    </div>
  </form>
</ng-container>
